import React from 'react';
import Spinner from '@airwallex/spinner';
import styled from '@emotion/styled';

export const CenteredFlex = styled.div<{ height?: string }>`
  width: 100%;
  height: ${({ height }) => height || '100vh'};
  display: flex;
  justify-content: center;
  align-items: center;
`;

type Props = {
  style?: React.CSSProperties;
};

const CustomSpinner = ({ style }: Props) => {
  return (
    <CenteredFlex style={style}>
      <Spinner primary show square={48} />
    </CenteredFlex>
  );
};

export default CustomSpinner;
